import {FC} from 'react'
import {KTSVG} from '../../../../../../../_metronic/helpers'
import UploadContactFooter from '../Element/UploadContactFooter'
import {UploadStep} from '..'
import {ENV} from '../../../../../../Utils/_helpers/EnvHelper'
import {Alert} from 'react-bootstrap'
const API_DOMAIN = ENV().REACT_APP_DOMAIN

export type ReviewProps = {
  report: any
  error: string
  isLoading: boolean
  handleClose: () => void
  setActiveState: (state: UploadStep) => void
  handleNext: () => void
  previousStep?: UploadStep
}

const Review: FC<ReviewProps> = (props) => {
  const {report, error, isLoading, handleClose, setActiveState, handleNext, previousStep} = props
  return (
    <div className='modal-body report'>
      {error.length > 0 && (
        <Alert variant='danger'>
          <Alert.Heading>Error</Alert.Heading>
          <p>{error}</p>
        </Alert>
      )}
      <div
        className='card bg-secondary'
        style={{
          maxWidth: '100%',
        }}
      >
        <div className='card-body '>
          <div className='row'>
            <div className='col-6 summary_block'>
              <span className='bg-white p-2 me-2 rounded'>
                <KTSVG
                  path='/media/icons/duotune/communication\com005.svg'
                  className='svg-icon-2x mb-2'
                />
              </span>
              <div className='summary_content'>
                <span>
                  <strong>{report?.data?.data?.totalContact}</strong>
                </span>
                <p className='text-muted'>Total contacts in list</p>
              </div>
            </div>
            <div className='col-6 summary_block'>
              <span className='bg-white p-2 me-2 rounded'>
                <KTSVG
                  path='/media/icons/duotune/general/gen028.svg'
                  className='svg-icon-2x mb-2'
                />
              </span>
              <div className='summary_content'>
                <span>
                  <strong>{report?.data?.data?.uniqueContact}</strong>
                  <p className='text-muted'>Unique contacts in list</p>
                </span>
              </div>
            </div>

            <div className='col-6 summary_block'>
              <span className='bg-white p-2 me-2 rounded'>
                <KTSVG
                  path='/media/icons/duotune/general/gen040.svg'
                  className='svg-icon-2x mb-2'
                />
              </span>
              <div className='summary_content'>
                <span>
                  <strong>{report?.data?.data?.duplicateContact}</strong>
                </span>
                <p className='text-muted'>Duplicate in list</p>
              </div>
            </div>
            <div className='col-6 summary_block'>
              <span className='bg-white p-2 me-2 rounded'>
                <KTSVG
                  path='/media/icons/duotune/general/gen044.svg'
                  className='svg-icon-2x mb-2'
                />
              </span>
              <div className='summary_content'>
                <span>
                  <strong>{report?.data?.data?.invalidContact}</strong>
                </span>
                <p className='text-muted'>Invalid Numbers</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='mt-5'>
        <p className='mb-0'>
          Review contact report. {' '}
          <a href={`${API_DOMAIN}/${report?.data?.data?.downloadUrl}`} style={{
            fontSize: 15
          }}> Download report</a>
        </p>
      </div>

      <UploadContactFooter
        allowedNext={!isLoading}
        isLoading={isLoading}
        isLast={true}
        handleClose={handleClose}
        handleNext={handleNext}
        handleBack={() => setActiveState(previousStep ? previousStep : UploadStep.Confirmation)}
      />
    </div>
  )
}

export default Review
